import ApprovedIcon from './ApprovedIcon';

export default ApprovedIcon;
